import { render, staticRenderFns } from "./TableTypeCustomFieldFund.vue?vue&type=template&id=379a5f9a"
import script from "./TableTypeCustomFieldFund.vue?vue&type=script&lang=js"
export * from "./TableTypeCustomFieldFund.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports